/** HTTP method constants. Pure leaf (zero VALUE imports) so sibling const leaves can reference HTTP_METHODS without triggering the `export` TDZ cycle the barrel would cause. */

import { GIT_HEAD_REF } from '@federa/const/cli-git';
import type { SelfKeyed } from '@federa/types/primitives-records';

const HTTP_METHODS_SOURCE = {
	GET: 'GET',
	POST: 'POST',
	PUT: 'PUT',
	DELETE: 'DELETE',
	PATCH: 'PATCH',
	HEAD: GIT_HEAD_REF,
	OPTIONS: 'OPTIONS',
} as const;

export const HTTP_METHODS: SelfKeyed<typeof HTTP_METHODS_SOURCE> = HTTP_METHODS_SOURCE;

export type HttpMethod = (typeof HTTP_METHODS)[keyof typeof HTTP_METHODS];
